import { render, staticRenderFns } from "./MapPopup.vue?vue&type=template&id=b0344462&lang=pug&"
import script from "./MapPopup.vue?vue&type=script&lang=js&"
export * from "./MapPopup.vue?vue&type=script&lang=js&"
import style0 from "./MapPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports